import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const CorporateCTA = () => {
  return (
    <section className="py-24 bg-muted">
      <div className="max-w-wide mx-auto px-4 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-8">
          {/* Investors CTA */}
          <div className="bg-white rounded-brand-lg p-8 lg:p-12 border border-border">
            <div className="w-14 h-14 bg-primary/10 rounded-brand flex items-center justify-center mb-6">
              <Icon name="TrendingUp" size={28} className="text-primary" />
            </div>
            <h3 className="text-2xl font-semibold text-foreground mb-4">
              Investor Relations
            </h3>
            <p className="text-muted-foreground mb-6">
              Access pitch materials, financial reports, and connect with our investor relations team.
              Learn about our growth metrics and expansion plans.
            </p>
            <ul className="space-y-3 mb-8">
              <li className="flex items-center text-sm text-foreground">
                <Icon name="FileText" size={16} className="text-accent mr-3" />
                Pitch deck and one-pager
              </li>
              <li className="flex items-center text-sm text-foreground">
                <Icon name="BarChart" size={16} className="text-accent mr-3" />
                Financial metrics and projections
              </li>
              <li className="flex items-center text-sm text-foreground">
                <Icon name="Users" size={16} className="text-accent mr-3" />
                Direct access to leadership
              </li>
            </ul>
            <Link
              to="/investor-relations"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary text-white font-medium rounded-brand-sm hover:bg-primary-light transition-colors"
            >
              Investor Portal
              <Icon name="ArrowRight" size={16} />
            </Link>
          </div>

          {/* Partners CTA */}
          <div className="bg-primary rounded-brand-lg p-8 lg:p-12 text-white">
            <div className="w-14 h-14 bg-white/10 rounded-brand flex items-center justify-center mb-6">
              <Icon name="Handshake" size={28} className="text-white" />
            </div>
            <h3 className="text-2xl font-semibold mb-4">
              Partnership Opportunities
            </h3>
            <p className="text-white/70 mb-6">
              Join our ecosystem as a strategic partner. We work with banks, governments,
              educational institutions, and corporate sponsors.
            </p>
            <ul className="space-y-3 mb-8">
              <li className="flex items-center text-sm">
                <Icon name="Building" size={16} className="text-accent-light mr-3" />
                Financial institutions
              </li>
              <li className="flex items-center text-sm">
                <Icon name="Landmark" size={16} className="text-accent-light mr-3" />
                Government programs
              </li>
              <li className="flex items-center text-sm">
                <Icon name="GraduationCap" size={16} className="text-accent-light mr-3" />
                Educational partners
              </li>
            </ul>
            <Link
              to="/partnerships"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white text-primary font-medium rounded-brand-sm hover:bg-white/90 transition-colors"
            >
              Explore Partnerships
              <Icon name="ArrowRight" size={16} />
            </Link>
          </div>
        </div>

        {/* Secondary Links */}
        <div className="mt-12 pt-12 border-t border-border">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <Link
              to="/technology"
              className="group flex items-center justify-between p-4 bg-white rounded-brand border border-border hover:border-primary/20 transition-colors"
            >
              <div className="flex items-center gap-3">
                <Icon name="Code" size={20} className="text-muted-foreground group-hover:text-primary transition-colors" />
                <span className="font-medium text-foreground">Technology</span>
              </div>
              <Icon name="ArrowRight" size={16} className="text-muted-foreground group-hover:text-primary transition-colors" />
            </Link>
            <Link
              to="/impact"
              className="group flex items-center justify-between p-4 bg-white rounded-brand border border-border hover:border-primary/20 transition-colors"
            >
              <div className="flex items-center gap-3">
                <Icon name="Heart" size={20} className="text-muted-foreground group-hover:text-primary transition-colors" />
                <span className="font-medium text-foreground">Impact</span>
              </div>
              <Icon name="ArrowRight" size={16} className="text-muted-foreground group-hover:text-primary transition-colors" />
            </Link>
            <Link
              to="/press"
              className="group flex items-center justify-between p-4 bg-white rounded-brand border border-border hover:border-primary/20 transition-colors"
            >
              <div className="flex items-center gap-3">
                <Icon name="Newspaper" size={20} className="text-muted-foreground group-hover:text-primary transition-colors" />
                <span className="font-medium text-foreground">Press</span>
              </div>
              <Icon name="ArrowRight" size={16} className="text-muted-foreground group-hover:text-primary transition-colors" />
            </Link>
            <Link
              to="/careers"
              className="group flex items-center justify-between p-4 bg-white rounded-brand border border-border hover:border-primary/20 transition-colors"
            >
              <div className="flex items-center gap-3">
                <Icon name="Briefcase" size={20} className="text-muted-foreground group-hover:text-primary transition-colors" />
                <span className="font-medium text-foreground">Careers</span>
              </div>
              <Icon name="ArrowRight" size={16} className="text-muted-foreground group-hover:text-primary transition-colors" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CorporateCTA;
